import React, { ReactNode } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
/*
  This component is a stopgap in order to deprecate @atlaskit/field-base

  New form components should be built using render props and a compliant
    form field label associated by an ID.
  https://atlassian.design/components/textfield/examples
*/

type FieldLabelProps = {
  children: string | ReactNode;
  htmlFor: string;
  isRequired?: boolean;
};

const Label = styled.label({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  display: 'inline-block',
  marginBottom: token('space.050'),
  marginRight: token('space.050'),
});

const RequiredWrapper = styled.span({
  color: token('color.text.danger', colors.R400),
  marginLeft: token('space.025'),
});

const FieldLabel = ({
  children,
  htmlFor,
  isRequired = false,
}: FieldLabelProps): JSX.Element => {
  return (
    <Label htmlFor={htmlFor}>
      {children}
      {isRequired && <RequiredWrapper aria-hidden>*</RequiredWrapper>}
    </Label>
  );
};

export default FieldLabel;
